import React from 'react';

import { ContainerHeader } from '~components';
import { faMoneyBill } from '~components/icon';
import TabContainer, { Tab } from '~components/TabContainer';
import { ClientSignupsContainer } from '~direct-debits/components/client-signups';
import { ConnectionManager } from '~direct-debits/components/connection';

const tabs: Tab[] = [
  {
    id: 'direct-debits-connection',
    title: 'Connection',
    component: ConnectionManager,
  },
  {
    id: 'direct-debits-client-signups',
    title: 'Client Signups',
    component: ClientSignupsContainer,
  },
];

const DirectDebitsContainer: React.FC = () => (
  <div className="p-2">
    <ContainerHeader icon={faMoneyBill} iconSize="1x" className="info" dataCy="direct-debits-header">
      Direct Debits — GoCardless
    </ContainerHeader>
    <TabContainer tabs={tabs} setPageTitle={false} />
  </div>
);

export default DirectDebitsContainer;
